import React from "react";
import DSCheckbox from "../../../system-design/DSCheckBox";
import DSBox from "../../../system-design/DSBox";
import DSTypography from "../../../system-design/DSTypography";
import { resizeCloudinary } from "../../../../utils/util";
import { Klydo } from "../../../../Types";

interface KlydoListCardProps {
  klydo: Klydo;
  isSelected: boolean;
  onToggleSelection: (id: string) => void;
}

const KlydoListCard: React.FC<KlydoListCardProps> = ({
  klydo,
  isSelected,
  onToggleSelection,
}) => {
  if (!klydo) {
    return null;
  }

  return (
    <DSBox
      sx={{
        display: "flex",
        alignItems: "center",
        padding: 1,
        borderRadius: 1,
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "action.hover",
        },
      }}
      onClick={() => onToggleSelection(klydo.id)}
    >
      <DSCheckbox
        checked={isSelected}
        onChange={() => onToggleSelection(klydo.id)}
        sx={{ marginRight: 2 }}
        onClick={(e) => e.stopPropagation()}
      />

      <DSBox
        sx={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          overflow: "hidden",
          marginRight: 2,
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "grey.200",
        }}
      >
        <video
          muted
          src={resizeCloudinary(klydo.loopUrl, 48)}
          loop
          autoPlay
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </DSBox>

      <DSBox sx={{ flex: 1, minWidth: 0 }}>
        <DSTypography variant="body2" noWrap>
          {klydo.name}
        </DSTypography>
      </DSBox>
    </DSBox>
  );
};

export default KlydoListCard;
